import React, { useState, useEffect, useRef } from "react";
import { ReactSVG } from "react-svg";
import { render } from "react-dom";
import Image from "next/image";
import Link from "next/link";

import HeaderNav from "../../includes/HeaderNav";
import Footer from "../../includes/Footer";
import BookingSec from "./BookingCTA";
import EardCTA from "./kyna/EardCTA";

import DSM5Image from "../../../public/assets/img/DSM5-Based-Diagnosis-and-Sociomographic-Profile-PMHA-Psychiatric-Outpatients-2017-2021-Data.png";
import ResearchPartnerUST from "../../../public/assets/img/Research-Partnership-with-UST.png";
import PartnershipwithPOZ from "../../../public/assets/img/Partnership-with-Power-of-Zero.png";
import PartnershipwithNoBully from "../../../public/assets/img/Partnership-with-NoBully.jpg";

// PARTNER LOGOS
// SCHOOLS
import AimLogo from "../../../public/assets/img/partner-logos/aim-logo.png";
import NULogo from "../../../public/assets/img/partner-logos/national-university-logo.png";
import USTRedCrossLogo from "../../../public/assets/img/partner-logos/ust-red-cross-logo.png";
import XavierULogo from "../../../public/assets/img/partner-logos/xavier-u-logo.png";

// WELFARE
import ChildrenIntLogo from "../../../public/assets/img/partner-logos/children-international-logo.png";
import FreseniusLogo from "../../../public/assets/img/partner-logos/fresenius-medical-care-logo.png";
import CouncilWelfareLogo from "../../../public/assets/img/partner-logos/council-welfare-children-logo.png";

// COMPANIES
import CargillLogo from "../../../public/assets/img/partner-logos/cargill-logo.png";
import JohnsonLogo from "../../../public/assets/img/partner-logos/johnson-and-johnson-logo.png";
import ObenGroupLogo from "../../../public/assets/img/partner-logos/oben-group-logo.png";
import PBBLogo from "../../../public/assets/img/partner-logos/pbb-logo.png";
import SunlifeLogo from "../../../public/assets/img/partner-logos/sunlife-logo.png";
import TaguigCityLogo from "../../../public/assets/img/partner-logos/taguig-city-health-office-logo.png";
import TelusLogo from "../../../public/assets/img/partner-logos/telus-logo.png";
import ToshibaLogo from "../../../public/assets/img/partner-logos/toshiba-logo.png";
import UnilabLogo from "../../../public/assets/img/partner-logos/unilab-logo.png";

const Merd = () => {
  return (
    <>
      {/* MAIN NAVIGATION */}
      <HeaderNav />

      {/* MERD HEADER */}
      <section className="lg:pt-[100px] pt-[85px]">
        <div className="bg-[url('/assets/img/merd-header-image.png')] bg-bottom bg-cover bg-no-repeat lg:min-h-[550px] sm:min-h-[350px] min-h-[200px]"></div>
        <div className="max-w-screen-2xl mx-auto md:px-10 sm:px-8 px-6 mt-16">
          <div className="lg:max-w-4xl mx-auto">
            <h1 className="max-w-2xl lg:text-5xl sm:text-4xl text-3xl !leading-tight">
              Monitoring, Evaluation, and Research Department
            </h1>
            <p className="text-justify sm:text-lg text-base leading-relaxed border-t border-t-gray-300 pt-10">
              PMHA develops systems for monitoring and evaluating programs
              leading to the creation of evidence-based studies on mental health
              and strengthening the Association's position as a credible
              institution for research.
            </p>
          </div>
        </div>
      </section>

      {/* MERD BODY */}
      <section className="max-w-screen-xl mx-auto sm:mt-10 py-10 md:px-10 sm:px-8 px-6">
        <div className="grid grid-cols-1 md:mb-4 mb-0">
          <div className="col-span-1">
            <h2 className="text-blue md:text-3xl text-2xl">
              Published Research:
            </h2>
          </div>
        </div>

        {/* DESKTOP VIEW */}
        <div className="lg:grid hidden lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0 pb-5">
          <div className="col-span-1">
            <p className="sm:text-lg text-base">
              DSM5-Based Diagnosis and Sociomographic Profile of the Philippine
              Mental Health Association Inc.'s Psychiatric Outpatients 2017-2021
              Data
            </p>
          </div>
          <div className="col-span-1">
            <h3 className="text-lg mb-0">
              Research Partnership with University of Santo Tomas:
            </h3>
            <p className="sm:text-lg text-base">
              Parental Attitudes & its Association with Lesbian & Gay Adult
              Positive Identities
            </p>
          </div>
        </div>
        <div className="lg:grid hidden lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0">
          <div className="col-span-1 lg:mb-0 md:mb-10 mb-6">
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={DSM5Image}
                alt="DSM5-Based Diagnosis and Sociomographic Profile"
                className="rounded-lg"
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={ResearchPartnerUST}
                alt="DSM5-Based Diagnosis and Sociomographic Profile"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* MOBILE VIEW */}
        <div className="lg:hidden grid lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0">
          <div className="col-span-1 lg:mb-0 md:mb-10 mb-6">
            <p className="sm:text-lg text-base pb-5">
              DSM5-Based Diagnosis and Sociomographic Profile of the Philippine
              Mental Health Association Inc.'s Psychiatric Outpatients 2017-2021
              Data
            </p>
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={DSM5Image}
                alt="DSM5-Based Diagnosis and Sociomographic Profile"
                className="rounded-lg"
              />
            </div>
          </div>
          <div className="col-span-1">
            <h3 className="text-lg mb-0">
              Research Partnership with University of Santo Tomas:
            </h3>
            <p className="sm:text-lg text-base pb-5">
              Parental Attitudes & its Association with Lesbian & Gay Adult
              Positive Identities
            </p>
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={ResearchPartnerUST}
                alt="DSM5-Based Diagnosis and Sociomographic Profile"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-screen-xl mx-auto mt-10 pb-14 md:px-10 sm:px-8 px-6">
        <div className="grid grid-cols-1 md:mb-4 mb-0">
          <div className="col-span-1">
            <h2 className="text-blue md:text-3xl text-2xl">
              Ongoing Research:
            </h2>
          </div>
        </div>

        {/* DESKTOP VIEW */}
        <div className="lg:grid hidden lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0 pb-5">
          <div className="col-span-1">
            <h3 className="text-lg mb-0">In Partnership with Power of Zero:</h3>
            <p className="sm:text-lg text-base">
              Power of Zero Character Strengths for Growing up in the Age of the
              Internet: Development of Learning Materials for Kindergartens in
              the Philippines
            </p>
          </div>
          <div className="col-span-1">
            <h3 className="text-lg mb-0">In Partnership with NoBully:</h3>
            <p className="sm:text-lg text-base">
              NoBully Solution Coach Training Contextualization in the
              Philippine Education System
            </p>
          </div>
        </div>
        <div className="lg:grid hidden lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0">
          <div className="col-span-1 lg:mb-0 md:mb-10 mb-6">
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={PartnershipwithPOZ}
                alt="Partnership with Power of Zero"
                className="rounded-lg"
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className="border border-gray-300 rounded-lg pt-1 px-1">
              <Image
                src={PartnershipwithNoBully}
                alt="Partnership with Power of Zero"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>

        {/* MOBILE VIEW */}
        <div className="lg:hidden grid lg:grid-cols-2 grid-cols-1 xl:gap-12 gap-8 pt-0">
          <div className="col-span-1 lg:mb-0 md:mb-10 mb-6">
            <h3 className="text-lg mb-0">In Partnership with Power of Zero:</h3>
            <p className="sm:text-lg text-base pb-5">
              Power of Zero Character Strengths for Growing up in the Age of the
              Internet: Development of Learning Materials for Kindergartens in
              the Philippines
            </p>
            <div className="border border-gray-300 rounded-lg">
              <Image
                src={PartnershipwithPOZ}
                alt="Partnership with Power of Zero"
                className="rounded-lg"
              />
            </div>
          </div>
          <div className="col-span-1">
            <h3 className="text-lg mb-0">In Partnership with NoBully:</h3>
            <p className="sm:text-lg text-base pb-5">
              NoBully Solution Coach Training Contextualization in the
              Philippine Education System
            </p>
            <div className="border border-gray-300 rounded-lg pt-1 px-1">
              <Image
                src={PartnershipwithNoBully}
                alt="Partnership with Power of Zero"
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* PARTNERS AND LINKAGES */}
      <section className="max-w-screen-2xl mx-auto py-20 md:px-10 sm:px-8 px-6">
        <h2 className="lg:text-4xl text-3xl text-center mb-10">
          Partnerships and Linkages
        </h2>

        <div className="grid xl:grid-cols-8 lg:grid-cols-6 md:grid-cols-5 sm:grid-cols-4 grid-cols-3 xl:gap-10 lg:gap-8 gap-6 mb-5">
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={AimLogo} alt="AimLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={NULogo} alt="NULogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={USTRedCrossLogo} alt="USTRedCrossLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={XavierULogo} alt="XavierULogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={ChildrenIntLogo} alt="ChildrenIntLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={FreseniusLogo} alt="FreseniusLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={CouncilWelfareLogo} alt="CouncilWelfareLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={CargillLogo} alt="CargillLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={JohnsonLogo} alt="JohnsonLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={ObenGroupLogo} alt="ObenGroupLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={PBBLogo} alt="PBBLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={SunlifeLogo} alt="SunlifeLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={TaguigCityLogo} alt="TaguigCityLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={TelusLogo} alt="TelusLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={ToshibaLogo} alt="ToshibaLogo" />
            </div>
          </div>
          <div className="col-span-1">
            <div className="partner-logo-wrap">
              <Image src={UnilabLogo} alt="UnilabLogo" />
            </div>
          </div>
        </div>
      </section>

      {/* Booking CTA */}
      <EardCTA />

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Merd;
